import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RequestService } from '@api/request.service';
import jalaliMoment = require('jalali-moment');
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-response-list',
  templateUrl: './response-list.component.html',
  styleUrls: ['./response-list.component.scss']
})
export class ResponseListComponent implements OnInit{
  filter;
  responseList;
  requestId;
  public destroy$ = new Subject<void>();
  sort = [
    { value: 0, viewValue: 'تاریخ' },
    { value: 2, viewValue: 'گران ترین' },
    { value: 1, viewValue: 'ارزان ترین' },
  ]
  constructor(
    private requestService: RequestService,
    public router: Router,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.requestId = this.activatedRoute.snapshot.params.id;
    localStorage.setItem('requestId', this.requestId);
    this.getResponseList()
  }
  changeServiceType(item) {
    if (item?.value === 0) {
      this.filter = 0;
    } else if (item?.value === 1) {
      this.filter = 1;
    } else if (item?.value === 2) {
      this.filter = 2;
    }
    this.getResponseList();
  }

  getResponseList(){
    this.requestService.getResponseList(+this.requestId, this.filter).pipe(takeUntil(this.destroy$)).subscribe(
      (res: any) => {
        this.responseList = res;
        this.responseList?.resList.forEach((element): any => {
          element.expiryDate = jalaliMoment(element.expiryDate).format('jYYYY/jMM/jDD hh:mm');
          element.createdDate = jalaliMoment(element.createdDate).format('jYYYY/jMM/jDD hh:mm');

        });
      }
    )
  }

}
